module.exports = __webpack_public_path__ + "static/media/Banner3_mob_new.da1c2c23.png";